import { render } from "./Frequency.vue?vue&type=template&id=35582fa8"
import script from "./Frequency.vue?vue&type=script&setup=true&lang=js"
export * from "./Frequency.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/notification/components/form/Frequency.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "35582fa8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('35582fa8', __exports__)) {
    api.reload('35582fa8', __exports__)
  }
  
  module.hot.accept("./Frequency.vue?vue&type=template&id=35582fa8", () => {
    api.rerender('35582fa8', render)
  })

}


export default __exports__